export default __webpack_public_path__ + "static/media/sunset-plane.4252c189.jpg";